import { render, staticRenderFns } from "./CardTabs.vue?vue&type=template&id=92c674fc&scoped=true&"
import script from "./CardTabs.vue?vue&type=script&lang=js&"
export * from "./CardTabs.vue?vue&type=script&lang=js&"
import style0 from "./CardTabs.vue?vue&type=style&index=0&id=92c674fc&prod&lang=css&"
import style1 from "./CardTabs.vue?vue&type=style&index=1&id=92c674fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c674fc",
  null
  
)

export default component.exports